var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealerImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dealer-Count",
    transform: "translate(-333.483 -102.483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6430",
    "data-name": "Rectangle 6430",
    width: 50,
    height: 50,
    transform: "translate(333.483 102.483)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dealer-count-2",
    "data-name": "dealer-count",
    d: "M-1966.169,25.165l-9.159-2.415a2.457,2.457,0,0,1-.944-.486l-8.539-7.04-3.792-2a2.649,2.649,0,0,1-1.275-1.564,2.818,2.818,0,0,1,.165-2.055l3.886-7.848a2.478,2.478,0,0,1,3.372-1.151l3.536,1.864,7.692-2.364a2.41,2.41,0,0,1,1.75.13l5.214,2.488h2.59l3.679-1.94a2.478,2.478,0,0,1,3.372,1.151l3.886,7.848a2.813,2.813,0,0,1,.165,2.055,2.646,2.646,0,0,1-1.275,1.564l-3.677,1.939-2.353,2.9a1.327,1.327,0,0,1-.151.161l-5.741,6.059a2.477,2.477,0,0,1-1.794.78A2.389,2.389,0,0,1-1966.169,25.165Zm-16.355-11.44,7.809,6.439,9.159,2.414,4.769-5.029-5-3.836-1.276,1.009a6.093,6.093,0,0,1-7.586,0l-.857-.678a2.7,2.7,0,0,1-1-1.944,2.746,2.746,0,0,1,.734-2.074l6.185-6.521a2.649,2.649,0,0,1,.287-.261l-1.213-.579-7.7,2.367Zm17.468-2.746,6.011,4.609,1.212-1.5-4.308-8.7h-5.664l-6.185,6.521.857.678a3.656,3.656,0,0,0,4.552,0l2.023-1.6a1.221,1.221,0,0,1,.759-.267A1.22,1.22,0,0,1-1965.056,10.978Zm5.4-6.335,3.886,7.848,2.8-1.474-3.886-7.848Zm-27.814,6.2,2.8,1.474,3.886-7.848-2.795-1.474Z",
    transform: "translate(2328.924 116.073)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerImage);
export default __webpack_public_path__ + "static/media/dealer_image.9f8f36f0a42fc486ed5e1a3096b1538e.svg";
export { ForwardRef as ReactComponent };